<section class="is-flex gap-24">
  <app-cp-compare-timerange></app-cp-compare-timerange>
  <app-cp-compare-scale></app-cp-compare-scale>
</section>